import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from './de'
import en from './en'

import SetupApi from '@/store/api/system/setup';

// console.log("store: ", store.getters.i18n);
Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: SetupApi.getLocale(),
    messages: { en, de },
    // silentTranslationWarn: process.env.NODE_ENV === 'production',
    silentTranslationWarn: true,
    warnHtmlInMessage: false,
})

// if (module.hot) {
//     module.hot.accept(['./en.js', './de.js'], () => {
//         i18n.setLocaleMessage('en', de)
//         i18n.setLocaleMessage('de', en)
//         // if (process.env.NODE_ENV !== 'production') {
//         //     console.log('hot reload', this, arguments)
//         // }
//     })
// }

export default i18n
